if (!customElements.get('work-grid')) {
  customElements.define(
    'work-grid',
    class WorkGrid extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('.work-grid__card'));
        this.filterBar = this.querySelector('[data-filters]');
        this.moreWrap = this.querySelector('[data-more]');
        this.initial = parseInt(this.dataset.initial, 10) || this.cards.length;
        this.filter = '*';
        this.expanded = false;

        if (this.filterBar) {
          this.filterBar.hidden = false;
          this.filterBar.querySelectorAll('[data-filter]').forEach((button) => {
            button.addEventListener('click', () => {
              this.filter = button.dataset.filter;
              this.filterBar.querySelectorAll('[data-filter]').forEach((other) => {
                other.classList.toggle('work-grid__filter--on', other === button);
              });
              this.render();
            });
          });
        }

        if (this.moreWrap) {
          this.moreWrap.querySelector('button').addEventListener('click', () => {
            this.expanded = true;
            this.render();
          });
        }

        this.render();
      }

      render() {
        let shown = 0;
        let hiddenByCap = 0;
        this.cards.forEach((card) => {
          const tags = (card.dataset.tags || '').split('|');
          const matches = this.filter === '*' || tags.indexOf(this.filter) > -1;
          let visible = matches;
          if (matches && this.filter === '*' && !this.expanded && shown >= this.initial) {
            visible = false;
            hiddenByCap += 1;
          }
          if (visible) shown += 1;
          card.hidden = !visible;
        });
        if (this.moreWrap) {
          this.moreWrap.hidden = !(this.filter === '*' && !this.expanded && hiddenByCap > 0);
        }
      }
    }
  );
}
